const initialState = {
  generalCalendar: {
    visitsRequireApproval: false,
    gapBetweenVisitsMinutes: 0,
    gapBetweenVisitsRequired: false,
    isSameCompanyConfig: true,
    isCompany: false,
    propertyId: null,
    selectedTabId: 'availability',
    schedule: {
      key: 1, // 1: Mon to Fri, 2: Saturday, 3: Custom
      isLoading: false,
    },
    propertyInfo: null,
    paginator: { page: 1, count: false, pageSize: 25 },
    loadingVisits: true,
    latestVisitEventsRequestId: null,
    latestVisitDataRequestId: null,
    isOpen: false,
    isLoadingConfig: true,
    isFilledConfig: false,
    isLoadingStatus: true,
    isFilledStatus: false,
    isOnSettings: false,
    isCancelingVisit: false,
    isConfirmingVisit: false,
    disableCalendarModal: {
      isOpen: false,
      isLoading: false,
    },
    enableCalendarModal: {
      isOpen: false,
      isLoading: false,
    },
    blockDateFullDaysModal: {
      isOpen: false,
      isLoading: false,
    },
    blockDateRangeDayModal: {
      isOpen: false,
      isLoading: false,
    },
    deleteBlockedDatesModal: {
      isLoading: false,
      isOpen: false,
    },
    customAvailabilityModal: {
      isLoading: false,
      isOpen: false,
    },
    cancelNonGuidedVisitModal: {
      isLoading: false,
      isOpen: false,
    },
    addContactModal: {
      isLoading: false,
      isOpen: false,
    },
    isDisabledCalendarBannerOpen: false,
    isDifferentConfigurationBannerOpen: false,
    isVisitDetailModalOpen: false,
    isCancelVisitModalOpen: false,
    isConfirmVisitModalOpen: false,
    isCalendarFilterModalOpen: false,
    selectedVisitToDetail: null,
    selectedVisitToCancel: null,
    groupedVisits: {},
    allVisits: [],
    selectedBlockedFullDates: [null, null],
    selectedBlockedRangeDate: null,
    filters: {
      status: 'ACTIVE',
      dateOption: 'all',
      dateValues: [null, null],
      customDates: [null, null],
      contact: null,
      property: null,
      agents: [],
    },
    availableDays: [0, 1, 2, 3, 4, 5, 6],
    customSchedule: null,
    blockedDates: [],
    allBlockedDates: [],
    loadingExceptions: true,
    blockedDatesToDelete: [],
    specificBlockedDateToDelete: null,
    disableCalendarCheckboxes: {
      disableAllPropertiesCalendar: false,
      cancelAllUpcomingBookedVisits: false,
    },
    durations: [15, 30, 45, 60],
    selectedDuration: null,
    cancelVisitOptions: {
      loadingVisitData: false,
      sendLinkToBookAnotherVisit: true,
      isValidatingTokkoChat: true,
      isTokkoChatAvailable: false,
      sendByEmail: false,
      sendByWhatsapp: false,
      selectedWhatsappAlternativeOption: null,
      isErrorFooterOpen: false,
      message: '',
      visitId: null,
      scheduleStatus: null,
    },
    confirmVisitOptions: {
      loadingVisitData: false,
      isValidatingTokkoChat: true,
      isTokkoChatAvailable: false,
      sendByEmail: false,
      sendByWhatsapp: false,
      selectedWhatsappAlternativeOption: null,
      isErrorFooterOpen: false,
      message: '',
      visitId: null,
    },
    participants: {
      producer: true,
      propertyAgent: false,
      contactAgent: false,
      owner: false,
      agents: [],
      preventCalendarOverlap: true,
      superpositionType: 0, // 0 at least one, 1 all
      isModifyingAvailability: true,
    },
    visitFields: {
      fixedFields: [
        {
          id: 'name',
          textKey: 'NameAndSurname',
          needed: true,
          required: true,
          disabled: true,
          requiredDisabled: false,
          isTextarea: false,
        },
        {
          id: 'email',
          textKey: 'Email',
          needed: false,
          required: false,
          disabled: true,
          requiredDisabled: true,
          isTextarea: false,
        },
        {
          id: 'phone',
          textKey: 'Phone',
          needed: false,
          required: false,
          disabled: true,
          requiredDisabled: true,
          isTextarea: false,
        },
        {
          id: 'comment',
          textKey: 'VisitComments',
          needed: false,
          required: false,
          disabled: false,
          requiredDisabled: false,
          isTextarea: true,
        },
      ],
      extraFields: [],
      inititializing: false,
      isAddingExtraField: false,
      isInputOpen: false,
      inputValue: '',
    },
    eventTypes: {
      list: [],
      loading: false,
    },
    addContactForm: {
      name: {
        value: '',
      },
      email: {
        value: '',
      },
      cellphone: {
        value: '',
        isValid: false,
        isValidated: false,
        isLoading: false,
        isError: false,
      },
      phone: {
        value: '',
      },
    },
  },
};

export default initialState;
